import styled from 'styled-components'

export const SearchInput = styled.input`
  max-width: 400px;
  padding: 0.25rem0.25rem;
  justify-content: flex-start;
`
